module.exports = __webpack_public_path__ + "img/Weapon_121.e267ab21.png";